import type { ReactNode } from 'react';

import { CALLOUT_BOX, CALLOUT_STYLE, type CalloutTone } from './blockStyles';

interface CalloutProps {
  tone?: CalloutTone;
  title?: string;
  children: ReactNode;
}

/** 본문 흐름에서 잠깐 벗어나 짚어야 하는 내용. 남발하면 아무도 안 읽는다. */
export function Callout({ tone = 'tip', title, children }: CalloutProps) {
  const style = CALLOUT_STYLE[tone];

  return (
    <aside className={`${CALLOUT_BOX} ${style.box}`}>
      <span aria-hidden className="leading-6">
        {style.icon}
      </span>
      <div>
        {title && (
          <strong className={`mb-0.5 block text-[13px] ${style.head}`}>
            {title}
          </strong>
        )}
        {children}
      </div>
    </aside>
  );
}
